import { Applicant, ProviderData, ThirdPartyData } from 'store/dashboard/types'
import { Box, Divider, Paper, Stack, Tooltip, Typography } from '@mui/material'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import OpenCloseButton from 'components/openCloseButton/OpenCloseButton'

type Props = {
  applicant: Applicant
  target?: boolean
  removeApplicant: (applicant: Applicant) => void
}

export default function BenchmarkApplicantCard({ applicant, target, removeApplicant }: Props) {
  const cardStyles = {
    backgroundColor: target ? 'primary.main' : 'transparent',
    color: target ? 'white' : 'normalGrey.main',
    borderRadius: '20px',
    borderColor: '#e8e8e8',
    padding: 1.1,
  }

  return (
    <div>
      <Paper variant="outlined" sx={cardStyles}>
        <Box sx={{ height: 'auto' }}>
          <Typography
            textTransform="capitalize"
            fontSize="13px"
            noWrap
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '100%',
            }}>
            {applicant.applicant_original_name.toLowerCase()}
          </Typography>
        </Box>
        <Box sx={{}} mt={0.8} width="100%" justifyContent="right" display="flex" alignItems="center">
          {!target && (
            <RemoveCircleOutlineIcon
              onClick={() => removeApplicant(applicant)}
              sx={{ cursor: 'pointer', color: 'primary.main', padding: 0, fontSize: '26px', mr: 0.8 }}
            />
          )}
          <OpenCloseButton onClick={() => {}} opened={false} width="22px" height="22px" mx="0" />
        </Box>
      </Paper>
    </div>
  )
}
